/**
 * Trial Signup Service
 * Talks to the PUBLIC /api/trial/* endpoints.
 * Deliberately separate from clientsAdminService — no auth token attached,
 * and it should not share an axios instance that injects admin credentials.
 */

import axios from 'axios';

const trialApi = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '/api/trial',
    headers: {
        'Content-Type': 'application/json'
    }
    // No Authorization header / interceptor here — this is a public endpoint.
});

const trialSignupService = {
    /**
     * Submit the trial signup form.
     * @param {Object} data - { workspaceName, domain, adminEmail, first_name, last_name, acceptedTerms }
     */
    signup: (data) => trialApi.post('/signup', data),

    /**
     * @param {string} slug
     * @returns {Promise<boolean>}
     */
    checkSlugAvailability: async (slug) => {
        const response = await trialApi.get('/slug-available', { params: { slug } });
        return response.data.available;
    },

    /**
     * @param {string} domain
     * @returns {Promise<boolean>}
     */
    checkDomainAvailability: async (domain) => {
        const response = await trialApi.get('/domain-available', { params: { domain } });
        return response.data.available;
    },

    /**
     * @param {string} workspaceName
     * @returns {Promise<string>} suggested slug
     */
    generateUniqueSlug: async (workspaceName) => {
        const response = await trialApi.post('/generate-slug', { workspaceName });
        return response.data.slug;
    }
    // Removed 2 Nov 2026 (S-6.2 pt 5.1): checkAdmin, for the switched-off GET /check-admin, which nothing called.
};

export default trialSignupService;
